import React from 'react'
import Combaintop from '../Components/Combaintop/Top'
import Combainbottom from '../Components/Combainbottom/Combainbottom'
import Breadcrumbs from '../Components/banner/New-banner';
import Location from '../Components/Location';
function Locations() {
  return (
    // <div>Locations</div>
    <>
    <Combaintop/>
   
    <Breadcrumbs/>
    <Location/> 
    <Combainbottom/>
    
    </>
)
}

export default Locations